const RegistrationLogins = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold">Registration Logins</h1>
      <p className="mt-4 text-sm text-muted-foreground">This log page is under construction.</p>
    </div>
  );
};

export default RegistrationLogins;
